import { render } from "./CreatePlayer.vue?vue&type=template&id=4d7116a6&scoped=true"
import script from "./CreatePlayer.vue?vue&type=script&lang=js"
export * from "./CreatePlayer.vue?vue&type=script&lang=js"

import "./CreatePlayer.vue?vue&type=style&index=0&id=4d7116a6&lang=scss&scoped=true"

import exportComponent from "/vercel/path3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7116a6"]])

export default __exports__